import styled from "styled-components";
import iconCalendar from "../../assets/icons/icons8-calendário-16.png"

export const Card = styled.div`

    background-color: ${props => (props.cancelada ? "##fafafb" : "#FFF")};
    width: ${props => props.isMobile ? "750px" : "900px"};
    height: ${props => props.isOpen ? 'auto' : 'auto'};
    border-radius: 10px;
    margin: auto;
    margin-top: 28px;
    margin-bottom: 30px;
    padding-left: 40px;
    padding-right: 40px;
    padding-top: 20px;
    padding-bottom: 20px;
    display: flex;
    flex-direction: column;     
    justify-content: space-around;
    box-shadow: 1px 2px 5px 1px rgba(29, 33, 41, 0.4);

    #tooltip[data-show] {
        display: block;
    }


    .row{
        display: flex;
        flex-direction: ${props => props.isOpen ? 'row-reverse' : 'row'};
        justify-content: space-between;

        .title-name{
            font-family: Lato;
            font-size: 24px;
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            color: #303848;
            margin-bottom: 0px;
            opacity: ${props => (props.cancelada ? "0.35" : "1")};

        }

        .subtitle{
            width: 45%;
            font-family: Lato;
            font-size: 11px;
            font-weight: bold;
            font-stretch: normal;
            font-style: italic;
            line-height: normal;
            letter-spacing: normal;
            color: #bac1cf;
            margin-bottom: 0px;
            opacity: ${props => (props.cancelada ? "0.35" : "1")};
            
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;

        }

        .item-right{
            text-align: right;
            display: flex;
            flex-direction: row;
            justify-content: flex-end;
            align-items: flex-start;

            .icons{
                width: ${props => props.estado === 'GO' || props.estado === 'SC' || props.estado === 'MT' || props.estado === 'ES' ? '160px' : '60px'};
                margin-left: 20px;
                display: flex;
                flex-direction: row;
                justify-content: ${props => props.cancelada ? 'center' : (props.estado === 'GO' || props.estado === 'SC' || props.estado === 'MT' || props.estado === 'ES' ? 'space-between' : 'flex-end')};

                .icons-buttons{
                    display: flex;
                    flex-direction: row;
                    align-items: center;

                    a{
                        p{
                            display:none;
                            position:absolute;
                            font-size: 11px;
                            font-weight: normal;
                            font-stretch: normal;
                            font-style: normal;
                            line-height: normal;
                            letter-spacing: normal;
                            text-align: center;
                            align-items: center;
                            padding-top: 2px;
                            color:#FFF;
                            background-color: #1d2129;
                            width: 63px;
                            height: 22px;
                            opacity: 0.9;
                            border-radius: 5px;
                            margin-left: -22px;
                            margin-top: 5px;
    
                            &:before{
                                position: absolute;
                                background-color:  #1d2129;
                                width: 8px;
                                height: 8px;
                                top: -4px;
                                margin-left: 17px;
                                content: '';
                                transform: rotate(45deg);
                            }
    
                        }
    
                        &:hover{
                            text-decoration: none;
                            p{
                                display: block;
                            }
                        }
                    }
    
    
                    img{
                        cursor: pointer;
                    }
                    
                    .cancel{
                        margin-left: 20px;
                        height: 18px;
                    }

                }

                .sidago-status-0 {
                    background-color: rgba(255, 82, 82, 0.12);
                    width: 90px;
                    height: 25px;
                    display: flex;
                    flex-direction: row;
                    justify-content: space-evenly;
                    align-items: center;
                    border-radius: 8px;
                    cursor: context-menu;

                    p {
                        display: flex;
                        text-align: center;
                        align-items: center;
                        margin: auto;
                        color: #d9261d;
                        font-family: Lato;
                        font-size: 11px;
                        font-weight: bold;
                        font-stretch: normal;
                        font-style: normal;
                        line-height: normal;
                        letter-spacing: normal;
                        cursor: context-menu;

                    }
                    img {
                        align-items: center;
                        margin: auto;
                        width: 20px;
                        cursor: context-menu;
                    }

                    #description {
                        display:none;
                    }

                    &:hover {
                        #description {
                            display:flex;
                            justify-content: center;
                            position:absolute;
                            font-size: 10px;
                            font-weight: normal;
                            font-stretch: normal;
                            font-style: normal;
                            line-height: normal;
                            text-align: center;
                            align-items: center;
                            color:#FFF;
                            background-color: #1d2129;
                            width: 80px;
                            height: 28px;
                            opacity: 0.9;
                            border-radius: 5px;
                            margin-top: 62px;

                            &:before{
                                display:flex;
                                position: absolute;
                                background-color:  #1d2129;
                                width: 8px;
                                height: 8px;
                                top: -4px;
                                margin-left: 17px;
                                content: '';
                                transform: rotate(45deg);
                            }
                        }

                    }

                    .status-icon {
                        cursor: context-menu;
                    }
                }
                .sidago-status-1 {
                    background-color: rgba(234,176,0, 0.20);
                    width: 90px;
                    height: 25px;
                    display: flex;
                    flex-direction: row;
                    justify-content: space-evenly;
                    align-items: center;
                    border-radius: 8px;
                    cursor: pointer;
                    box-shadow: 2px 2px 2px 0px rgb(29 33 41 / 12%);


                    p {
                        display: flex;
                        text-align: center;
                        align-items: center;
                        margin: auto;
                        color: #ce9c09;
                        font-family: Lato;
                        font-size: 11px;
                        font-weight: bold;
                        font-stretch: normal;
                        font-style: normal;
                        line-height: normal;
                        letter-spacing: normal;
                        cursor: pointer;

                    }
                    img {
                        align-items: center;
                        margin: auto;
                        width: 20px;
                        cursor: pointer;
                    }

                    #description {
                        display:none;
                    }
                    transition: all 0.2s;


                    &:hover {
                        transform: scale(1.05);
                        transition: all 0.2s;
                        #description {
                            display:flex;
                            justify-content: center;
                            position:absolute;
                            font-size: 10px;
                            font-weight: normal;
                            font-stretch: normal;
                            font-style: normal;
                            line-height: normal;
                            text-align: center;
                            align-items: center;
                            color:#FFF;
                            background-color: #1d2129;
                            width: 80px;
                            height: 28px;
                            opacity: 0.9;
                            border-radius: 5px;
                            margin-top: 62px;

                            &:before{
                                display:flex;
                                position: absolute;
                                background-color:  #1d2129;
                                width: 8px;
                                height: 8px;
                                top: -4px;
                                margin-left: 17px;
                                content: '';
                                transform: rotate(45deg);
                            }
                        }

                    }

                    &:active {
                        transform: scale(0.9);
                    }

                    .status-icon {
                        cursor: pointer;
                    }
                }

                .sidago-status-2 {
                    background-color: rgba(234,176,0, 0.20); //alterado cor de azul para amarelo RA-374
                    width: 90px;
                    height: 25px;
                    display: flex;
                    flex-direction: row;
                    justify-content: space-evenly;
                    align-items: center;
                    border-radius: 8px;
                    cursor: pointer;
                    box-shadow: 2px 2px 2px 0px rgb(29 33 41 / 12%);


                    p {
                        display: flex;
                        text-align: center;
                        align-items: center;
                        margin: auto;
                        color: #589bff;
                        font-family: Lato;
                        font-size: 11px;
                        font-weight: bold;
                        font-stretch: normal;
                        font-style: normal;
                        line-height: normal;
                        letter-spacing: normal;
                        cursor: pointer;
                    }

                    #description {
                        display:none;
                    }
                    transition: all 0.2s;


                    &:hover {
                        transform: scale(1.05);
                        transition: all 0.2s;
                        #description {
                            display:flex;
                            justify-content: center;
                            position:absolute;
                            font-size: 10px;
                            font-weight: normal;
                            font-stretch: normal;
                            font-style: normal;
                            line-height: normal;
                            text-align: center;
                            align-items: center;
                            color:#FFF;
                            background-color: #1d2129;
                            width: 80px;
                            height: 28px;
                            opacity: 0.9;
                            border-radius: 5px;
                            margin-top: 62px;

                            &:before{
                                display:flex;
                                position: absolute;
                                background-color:  #1d2129;
                                width: 8px;
                                height: 8px;
                                top: -4px;
                                margin-left: 17px;
                                content: '';
                                transform: rotate(45deg);
                            }
                        }

                    }

                    &:active {
                        transform: scale(0.9);
                    }


                    img {
                        align-items: center;
                        margin: auto;
                        width: 20px;
                        cursor: pointer;
                    }

                    .status-icon {
                        cursor: pointer;
                    }
                }

                .sidago-status-3 {
                    background-color: rgba(47, 187, 105, 0.12);
                    width: 90px;
                    height: 25px;
                    display: flex;
                    flex-direction: row;
                    justify-content: space-evenly;
                    align-items: center;
                    border-radius: 8px;
                    cursor: context-menu;


                    p {
                        display: flex;
                        text-align: center;
                        align-items: center;
                        margin: auto;
                        color: #03903e;
                        font-family: Lato;
                        font-size: 11px;
                        font-weight: bold;
                        font-stretch: normal;
                        font-style: normal;
                        line-height: normal;
                        letter-spacing: normal;
                        cursor: context-menu;

                    }

                    
                    img {
                        align-items: center;
                        margin: auto;
                        width: 20px;
                        cursor: context-menu;
                    }

                    #description {
                        display:none;
                    }

                    &:hover {
                        #description {
                            display:flex;
                            justify-content: center;
                            position:absolute;
                            font-size: 10px;
                            font-weight: normal;
                            font-stretch: normal;
                            font-style: normal;
                            line-height: normal;
                            text-align: center;
                            align-items: center;
                            color:#FFF;
                            background-color: #1d2129;
                            width: 75px;
                            height: 22px;
                            opacity: 0.9;
                            border-radius: 5px;
                            margin-top: 62px;

                            &:before{
                                display:flex;
                                position: absolute;
                                background-color:  #1d2129;
                                width: 8px;
                                height: 8px;
                                top: -4px;
                                margin-left: 17px;
                                content: '';
                                transform: rotate(45deg);
                            }
                        }

                    }

                    .status-icon {
                        cursor: context-menu;
                    }
                }
                
                .sidago-status-4 {
                    background-color: rgba(255, 82, 82, 0.12);
                    width: 90px;
                    height: 25px;
                    display: flex;
                    flex-direction: row;
                    justify-content: space-evenly;
                    align-items: center;
                    border-radius: 8px;
                    cursor: pointer;
                    box-shadow: 2px 2px 2px 0px rgb(29 33 41 / 12%);


                    p {
                        display: flex;
                        text-align: center;
                        align-items: center;
                        margin: auto;
                        color: #d9261d;
                        font-family: Lato;
                        font-size: 11px;
                        font-weight: bold;
                        font-stretch: normal;
                        font-style: normal;
                        line-height: normal;
                        letter-spacing: normal;
                        cursor: pointer;

                    }
                    img {
                        align-items: center;
                        margin: auto;
                        width: 20px;
                        cursor: pointer;
                    }

                    #description {
                        display:none;
                    }
                    
                    transition: all 0.2s;

                    &:hover {
                        transform: scale(1.05);
                        transition: all 0.2s;
                        #description {
                            display:flex;
                            justify-content: center;
                            position:absolute;
                            font-size: 10px;
                            font-weight: normal;
                            font-stretch: normal;
                            font-style: normal;
                            line-height: normal;
                            text-align: center;
                            align-items: center;
                            color:#FFF;
                            background-color: #1d2129;
                            width: 80px;
                            height: 28px;
                            opacity: 0.9;
                            border-radius: 5px;
                            margin-top: 62px;

                            &:before{
                                display:flex;
                                position: absolute;
                                background-color:  #1d2129;
                                width: 8px;
                                height: 8px;
                                top: -4px;
                                margin-left: 17px;
                                content: '';
                                transform: rotate(45deg);
                            }
                        }

                    }

                    &:active {
                        transform: scale(0.9);
                    }

                    .status-icon {
                        cursor: pointer;
                    }
                }


                .info-cancel{
                        width: 93px;
                        height: 25px;
                        border-radius: 5px;
                        background-color: #f3f3f5;
                        margin-left: 10px;
                        opacity: 10;
    
                        p{
                            font-family: Lato;
                            font-size: 12px;
                            font-weight: bold;
                            font-stretch: normal;
                            font-style: normal;
                            line-height: normal;
                            letter-spacing: normal;
                            text-align: center;
                            color: #ff5252;
                            padding: 5px;
                        }
                    }
            }

            .agronomo {
                margin-top: -5px;

                .lbl-item{
                    text-align: end;
                }
            }
        }


        .lbl-item{
            font-family: Lato;
            font-size: 11px;
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            color: #bac1cf;
            margin-bottom: 0px;
            opacity: ${props => (props.cancelada ? "0.35" : "1")};

        }
        
        .lbl-item-fabricante{
            font-family: Lato;
            font-size: 11px;
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            color: #303848;
            margin-bottom: 0px;
            opacity: ${props => (props.cancelada ? "0.35" : "1")};    
        }

        .lbl-info-fabricante {
            font-family: Lato;
            font-size: 11px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            color: #bac1cf;
            margin-bottom: 0px;
            opacity: ${props => (props.cancelada ? "0.35" : "1")};
        }

        .lbl-info{
            max-width: 300px;
            font-family: Lato;
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            color: #303848;
            margin-bottom: 0px;
            opacity: ${props => (props.cancelada ? "0.35" : "1")};


        }


        .lbl-info-local{
            max-width: 300px;
            font-family: Lato;
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            color: #589bff;
            margin-bottom: 0px;
            opacity: ${props => (props.cancelada ? "0.35" : "1")};

            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;

            img{
                margin-top: -4px;
            }

        }


        .item {
            width: 46%
        }

    }

    .rowBtn {
        width: 40%;
        margin: auto;
    }

    @media only screen and (max-width: 1024px) {
        width: 100%;
    }

    @media only screen and (max-width: 768px) {
        width: 100%;
        padding-left: 10px;
        padding-right: 10px;
    }

    @media only screen and (max-width: 600px) {
        margin-top: 42px;
        margin-bottom: -5px;

        .rowBtn {
            width: 100%;
        }
    }
`;


export const Row = styled.div`
    width: ${props => props.width ? props.width : '100%'};
    height: auto;
    display: ${props => props.isMobile ? 'none' : props.isDisplay ? 'flex' : 'flex'};
    flex-direction: ${props=> props.direction ? props.direction : 'row'};
    justify-content: ${props=> props.justifyContent ? props.justifyContent : 'start'};
    align-items: center;

    margin-bottom:  ${props => props.marginBottom ? props.marginBottom : '0px'};

    @media only screen and (max-width: 600px) {
        display: ${props => props.isMobile ? 'flex' : props.isDisplay ? 'none' : 'flex'};
        flex-direction: ${props => props.responsiveReverse ? 'column-reverse' : props.isTitle ? 'row' : 'column'};
        align-items: ${props => props.responsiveReverse ? 'flex-start' : props.align ? props.align : 'center'};
        width: ${props => props.widthResponsive ? props.widthResponsive : '100%'};
        margin-right: ${props => props.widthResponsive ? '10px' : '0px'};
    }
`;

export const Col = styled.div`
    width: ${props => props.width ? props.width : '50%'};
    height: auto;
    display: flex;
    flex-direction: ${props => props.direction ? props.direction : 'column'};
    justify-content: ${props => props.justifyContent ? props.justifyContent : 'flex-start'};
    margin-left: ${props => props.marginLeft ? props.marginLeft : '0px'};

    @media only screen and (max-width: 600px) {
        flex-direction: ${props => props.isTitle ? 'column' : props.direction ? props.direction : props.responsiveReverse ? 'column' : 'row'};
        width: ${props => props.responsiveReverse && props.width ? props.width : '100%'};
        margin-top: ${props => props.responsiveReverse && props.marginTop ? props.marginTop : '0px'};
        margin-bottom: ${props => props.responsiveReverse && props.marginTop ? '0px' : '10px'};
        align-items: ${props => props.alignItems ? props.align ? props.align : props.alignItems : props.alignResponsive ? props.alignResponsive :'flex-start'};
        justify-content: space-between;
    }
`;

export const Title = styled.label`
    font-family: Lato;
    font-size: 24px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #303848;
    margin-bottom: 0px;
    opacity: ${props => (props.cancelada ? "0.35" : "1")};

`;

export const ScientificName = styled.label`
    font-family: Lato;
    font-size: 11px;
    font-weight: bold;
    font-stretch: normal;
    font-style: italic;
    line-height: normal;
    letter-spacing: normal;
    color: #bac1cf;
    margin-bottom: 0px;
    opacity: ${props => (props.cancelada ? "0.35" : "1")};
    
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: center;
    padding-top: 6px;
    padding-left: 10px;
    padding-right: 10px;
`;

export const Manufacturer = styled.label`
    font-family: Lato;
    font-size: 11px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #303848;
    margin-bottom: 0px;
    opacity: ${props => (props.cancelada ? "0.35" : "1")};   
`;

export const ManufacturerName = styled.label`
    font-family: Lato;
    font-size: 11px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #bac1cf;
    margin-bottom: 0px;
    opacity: ${props => (props.cancelada ? "0.35" : "1")};
    padding-left: 10px;
`;

export const Item = styled.label`
    font-family: Lato;
    font-size: 11px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #bac1cf;
    margin-bottom: 0px;
    text-align: ${props => props.align ? props.align : 'start'};
    opacity: ${props => (props.cancelada ? "0.35" : "1")};
`;

export const Info = styled.label`
    max-width: 100%;
    font-family: Lato;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #303848;
    margin-bottom: 0px;
    opacity: ${props => (props.cancelada ? "0.35" : "1")};

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const InfoFarm = styled.label`
    max-width: 100%;
    font-family: Lato;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #589bff;
    margin-bottom: 0px;
    opacity: ${props => (props.cancelada ? "0.35" : "1")};

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    img{
        margin-top: -4px;
    }
`;

export const Icons = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-left: 20px;

    #send {

        svg {
            transition: all 0.2s ease;
            &:hover{
                transform: scale(1.15);
            }
        }


        p{
            width: auto;
            height: 22px;
            padding: 4px 10px 0px;

            display:none;
            flex-direction: row;
            justify-content: center;
            position:absolute;
            align-items: center;

            font-size: 11px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            text-align: center;
            
            margin-top: 5px;
            margin-left: -16px;
            
            /* padding-top: 2px; */
            
            color:#FFF;
            background-color: #1d2129;
            opacity: 0.9;
            
            border-radius: 5px;

            &:before{
                position: absolute;
                background-color:  #1d2129;
                width: 8px;
                height: 8px;
                top: -4px;
                margin-left: 17px;
                content: '';
                transform: rotate(45deg);
            }

        }
        svg g{
            fill: #424754
        }

        &:hover{
            text-decoration: none;
            p{
                display: block;
            }
        }
    }

    a{
        


        p{
            width: 63px;
            height: 22px;

            display:none;
            position:absolute;
            align-items: center;

            font-size: 11px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            text-align: center;
            
            margin-top: 5px;
            margin-left: -22px;
            
            padding-top: 2px;
            
            color:#FFF;
            background-color: #1d2129;
            opacity: 0.9;
            
            border-radius: 5px;

            &:before{
                position: absolute;
                background-color:  #1d2129;
                width: 8px;
                height: 8px;
                top: -4px;
                margin-left: 17px;
                content: '';
                transform: rotate(45deg);
            }

        }

        &:hover{
            text-decoration: none;
            p{
                display: block;
            }
        }
    }


    img{
        cursor: pointer;
        
        transition: all 0.2s ease;
        &:hover{
            transform: scale(1.15);
        }
    }
    
    .cancel{
        margin-left: 20px;
        height: 18px;
    }

    @media only screen and (max-width: 600px) { 
        margin-left: 0px;
    }
`;

export const BtnHomolog = styled.div`
    background-color: ${props => props.status === 0 ? 'rgba(255, 82, 82, 0.12)' : props.status === 1 ? 'rgba(234,176,0, 0.20)' : props.status === 2 ? 'rgba(234,176,0, 0.20)' : props.status === 3 ? 'rgba(47, 187, 105, 0.12)' : props.status === 4 ? 'rgba(255, 82, 82, 0.12)' : 'transparent'};
    width: 90px;
    height: 25px;
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    align-items: center;
    border-radius: 8px;
    cursor: ${props => props.status === 0 ? 'context-menu' : props.status === 1 ? 'pointer' : props.status === 2 ? 'pointer' : props.status === 3 ? 'context-menu' : props.status === 4 ? 'pointer' : 'context-menu'};
    box-shadow: ${props => props.status === 1 ||props.status === 2 ||props.status === 4 ? '2px 2px 2px 0px rgb(29 33 41 / 12%)' : 'none'};

    p {
        display: flex;
        text-align: center;
        align-items: center;
        margin: auto;
        color: ${props => props.status === 0 ? '#d9261d' : props.status === 1 ? '#ce9c09' : props.status === 2 ? '#ce9c09' : props.status === 3 ? '#03903e' : props.status === 4 ? '#d9261d' : 'transparent'};
        font-family: Lato;
        font-size: 11px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        cursor: ${props => props.status === 0 ? 'context-menu' : props.status === 1 ? 'pointer' : props.status === 2 ? 'pointer' : props.status === 3 ? 'context-menu' : props.status === 4 ? 'pointer' : 'context-menu'};
    }

    #msg {
        display: none;
    }

    &:hover {
        #msg {
            display: flex;
            justify-content: center;
            position:absolute;
            font-size: 10px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            text-align: center;
            align-items: center;
            color:#FFF;
            background-color: #1d2129;
            width: 80px;
            height: 28px;
            opacity: 0.9;
            border-radius: 5px;
            margin-top: 62px;
    
            &:before{
                display:flex;
                position: absolute;
                background-color:  #1d2129;
                width: 8px;
                height: 8px;
                top: -4px;
                margin-left: 17px;
                content: '';
                transform: rotate(45deg);
            }
        }
    }

    img {
        align-items: center;
        margin: auto;
        width: 20px;
        cursor: ${props => props.status === 0 ? 'context-menu' : props.status === 1 ? 'pointer' : props.status === 2 ? 'pointer' : props.status === 3 ? 'context-menu' : props.status === 4 ? 'pointer' : 'context-menu'};
    }

    .status-icon {
        cursor: ${props => props.status === 0 ? 'context-menu' : props.status === 1 ? 'pointer' : props.status === 2 ? 'pointer' : props.status === 3 ? 'context-menu' : props.status === 4 ? 'pointer' : 'context-menu'};
    }
`;

export const Tooltip = styled.p`
    display:none;
`;

export const Cancelada = styled.div`
    width: 93px;
    height: 25px;
    border-radius: 5px;
    background-color: #f3f3f5;
    margin-left: 10px;
    opacity: 10;

    p{
        font-family: Lato;
        font-size: 12px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: center;
        color: #ff5252;
        padding-top: 5px;
    }
`;

export const ButtonExport = styled.div`

    
    @-webkit-keyframes rotating /* Safari and Chrome */ {
        from {
            -webkit-transform: rotate(0deg);
            -o-transform: rotate(0deg);
            transform: rotate(0deg);
        }
        to {
            -webkit-transform: rotate(360deg);
            -o-transform: rotate(360deg);
            transform: rotate(360deg);
        }
    }

    @keyframes rotating {
        from {
            -ms-transform: rotate(0deg);
            -moz-transform: rotate(0deg);
            -webkit-transform: rotate(0deg);
            -o-transform: rotate(0deg);
            transform: rotate(0deg);
        }
        to {
            -ms-transform: rotate(360deg);
            -moz-transform: rotate(360deg);
            -webkit-transform: rotate(360deg);
            -o-transform: rotate(360deg);
            transform: rotate(360deg);
        }
    }   

    img {
        -webkit-animation: rotating 0.7s linear infinite;
        -moz-animation: rotating 0.7s linear infinite;
        -ms-animation: rotating 0.7s linear infinite;
        -o-animation: rotating 0.7s linear infinite;
        animation: rotating 0.7s linear infinite;
    }

`;
export const Data = styled.div`
    width: 296px;
    height: 50px;
    border-radius: 25px;
    background-color: #f3f3f5;
    display: flex;
    justify-content: center;
    align-items: center;


    .input-data-filter{
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;

        .input-date{
            border: none;
            border-right: 1px;
            background-color: #f3f3f5;
            padding-right: 25px;
            height: 40px;
        }

        .input-date + .input-date{
            border-left: solid 1px #dfe4eb;
            padding-left: 25px;
            padding-right: 0px;
        }

        input[type="date"]::-webkit-calendar-picker-indicator{
            color: rgba(0, 0, 0, 0);
            opacity: 1;
            display: block;
            background: url(${iconCalendar}) no-repeat;
            border-width: thin;
            margin-top: 5px;
        }

        input[type="date"]::-webkit-inner-spin-button{
            margin-top: 8px;
        }

    }
`;